import { Component, EventEmitter, h, Prop, Event, Listen, State } from '@stencil/core';
import { ClearAllEvent, FacetUpdateEvent } from '@hpfc/fc-frontend-core';

/**
 * @description The fccd-facet-select creates a select wrapped with a panel.
 * @use
 */
@Component({
  tag: 'fccd-clear-all',
  styleUrl: 'clear-all.scss',
})
export class ClearAll {
  /**
   * The id for the element in this component.
   */
  @Prop() elementId!: string;

  @State() showClearFilters: boolean = false;

  /**
   * Dispatches this event when a selection is made.
   */
  @Event() fccdClearAllEvent: EventEmitter<ClearAllEvent>;

  private clearFilters() {
    this.fccdClearAllEvent.emit(new ClearAllEvent());
    this.showClearFilters = false;
  }

  @Listen('fccdComponentEvent', { target: 'document' })
  updateHandler(event: CustomEvent<FacetUpdateEvent>) {
    if (event?.detail?.facetMap) {
      // Ignore anything that blocks the pill or is not selected. Some filters
      // may exist for system reasons but aren't selected yet.
      const filter = [...event.detail.facetMap].filter(([, value]) => value.pillBlockDisabled || value.selected === false);
      const limit = filter && filter.length > 0 ? filter.length : 1;
      this.showClearFilters = event.detail.facetMap.size > limit;
    }
  }

  private getButtonName(): string {
    return 'clear-' + this.elementId;
  }

  // Notes on the hp5-select it does not allow empty label text so we are feeding it an empty string.
  render() {
    return (
      <div>
        {this.showClearFilters && (
          <hp5-button-decorator type="tertiary" size="md">
            <button
              class="clearall"
              type="button"
              id={this.getButtonName()}
              onClick={() => {
                this.clearFilters();
              }}
            >
              Clear filters
            </button>
          </hp5-button-decorator>
        )}
      </div>
    );
  }
}
